// extracted by mini-css-extract-plugin
module.exports = {"page":"pages-systemJobs-systemJobs__page--1KNf-","actions":"pages-systemJobs-systemJobs__actions--2qYnV"};